class UiConfig{
  constructor(){
    jQuery(document).ready( function($) {

      $('#wrapper-booking').off('keydown.bs.carousel');
    
      $.datepicker.regional['fr'] = {
        closeText: 'Fermer',
        prevText: '&#x3c;Préc',
        nextText: 'Suiv&#x3e;',
        currentText: 'Aujourd\'hui',
        monthNames: ['Janvier','Février','Mars','Avril','Mai','Juin',
        'Juillet','Aout','Septembre','Octobre','Novembre','Décembre'],
        monthNamesShort: ['Jan','Fev','Mar','Avr','Mai','Jun',
        'Jul','Aou','Sep','Oct','Nov','Dec'],
        dayNames: ['Dimanche','Lundi','Mardi','Mercredi','Jeudi','Vendredi','Samedi'],
        dayNamesShort: ['Dim','Lun','Mar','Mer','Jeu','Ven','Sam'],
        dayNamesMin: ['Di','Lu','Ma','Me','Je','Ve','Sa'],
        weekHeader: 'Sm',
        dateFormat: 'dd/mm/yy',
        firstDay: 1,
        isRTL: false,
        showMonthAfterYear: false,
        yearSuffix: '',
      };
      $.datepicker.setDefaults($.datepicker.regional['fr']);
    
      let date_booked = $('#datepicker').data('booked');
    
      $('#datepicker').datepicker({
        numberOfMonths: window.innerWidth > 768 ? 2 : 1,
        minDate: new Date(),
    
        beforeShowDay: function(date) {
          var string = $.datepicker.formatDate('dd/mm/yy', date);
          if(date_booked.indexOf(string) != -1) {
            return false;
          } else {
            var date1 = $.datepicker.parseDate($.datepicker._defaults.dateFormat, $('#date_b').val());
            var date2 = $.datepicker.parseDate($.datepicker._defaults.dateFormat, $('#date_e').val());
            return [true, date1 && ((date.getTime() == date1.getTime()) || (date2 && date >= date1 && date <= date2)) ? 'dp-highlight' : ''];
          }
        },
        onSelect: function(dateText, inst) {
          console.log(inst);
          $('.your-stay').addClass('hidden');
          var date1 = $.datepicker.parseDate($.datepicker._defaults.dateFormat, $('#date_b').val());
          var date2 = $.datepicker.parseDate($.datepicker._defaults.dateFormat, $('#date_e').val());
    
          if (!date1 || date2) {
            $('#date_b').val(dateText);
            $('#date_e').val('');
            $(this).datepicker('option', 'minDate', dateText); //HERE
          } else {
            $('#date_e').val(dateText);
            $('.your-stay').addClass('waiting');
            $(this).datepicker('option', 'minDate', new Date()); // OR HERE
    
            // Ajax
            let date_start = $('#date_b').val();
            let date_end = $('#date_e').val();
            let reference_lot = $('.your-stay').attr('data-lot');
            calcul_price(reference_lot, date_start, date_end);
          }
        },  
      });
    
      function calcul_price(reference_lot, date_start, date_end) {
        jQuery.post(
          ajaxUrl,
          {
            'action': 'omwajaxprice',
            'reference_lot': reference_lot,
            'date_start': date_start,
            'date_end': date_end,
          },
          function(response){
            $('.result .ajax').html(response).promise().done(function(){
              $('.result .ajax .cta .btn').click(function(e){
                $('#form-booking .item.item-1').slideUp(300);
                $('#form-booking .item.item-2').slideDown(300);
                e.preventDefault();
              })
              $('.result .ajax .helper .change-dates').click(function(e){
                $('#form-booking .item.item-1').slideDown(300);
                $('#form-booking .item.item-2').slideUp(300);
                e.preventDefault();
              })
            });
            $('div.your-stay').removeClass('hidden');
            $('div.your-stay').removeClass('waiting');
          }
        );
      }
    
    
    
      $('#form-booking').submit(function(event) {
        event.preventDefault();
    
        var values = $(this).serialize();
    
        jQuery.post(
          ajaxUrl,
          {
            'action': 'omwrequesthelios',
            'data': values,
          },
          function(response){
            $('.wrapper-booking-form').html(response);
          }
        );
      });
    
    });
  }
}
export default UiConfig;


// WEBPACK FOOTER //
// ./scripts/util/UiConfig.js